import React from 'react'
import {useHistory} from 'react-router-dom'
import Chip from '@mui/material/Chip'

export default function FilterChip(props) {

  const history = useHistory()
  const {name, createLabel = a => a, context, path} = props

  const label = createLabel(context.query[name])

  function handleDelete () {
    const query = {...context.query, [name]: undefined}
    history.push(context.linkQuery(path, {...context.query, [name]: undefined}))
  }

  return (<Chip label={label} onDelete={handleDelete} className="filter-chip" />)
}

